import { parseTaskDate, reverseDate } from '../../../../utils/calendarUtils';
import { Dispatch, SetStateAction } from 'react';
import { ConfirmedDealCard } from 'src/features/deals/ConfirmedDealCards/components';
import { CircularProgress } from '@mui/joy';
import { useGetVisitsQuery } from '../../../../api/visitasApi';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
    dateSelected: string;
    setShowModal: Dispatch<SetStateAction<boolean>>;
}

export function ConfirmedDealsContainer({ dateSelected, setShowModal }: Props) {

    const { data: deals, isLoading } = useGetVisitsQuery({ fecha: dateSelected, formatResponse: "list" });

    return (
        <div className="bg-white w-3/4 h-3/4 rounded flex flex-col">

            <div className="flex justify-end bg-gray-100 rounded p-2 h-[42px]">
                <button onClick={() => setShowModal(false)}>
                    <CloseRoundedIcon  />
                </button>
            </div>

            {isLoading
            ? 
            <div className="flex justify-center items-center h-full">
                <CircularProgress />
            </div>
            :
            <div className="flex flex-col p-3 h-full overflow-hidden">

                <p className="text-3xl font-semibold mb-4">Visitas del {dateSelected != null ? reverseDate(parseTaskDate(dateSelected)) : ""}</p>

                <div className="flex flex-col h-full gap-y-4 overflow-auto">
                    {deals?.length == 0 && (
                    <p className="text-xl font-semibold">No hay visitas para este dia</p>
                    )}
                    {deals?.map((deal, index) => (
                        <ConfirmedDealCard 
                            key={index}
                            deal={deal}/>
                ))}
                </div>
            </div>
            }

        </div>

    );
}
